<template>
  <div class="my-select" @mouseenter="mouseenter" @mouseleave="showClose = false">
    <el-dropdown
      style="width: 100%;"
      trigger="click"
      @visible-change="visibleChange"
      @command="chooseItem"
    >
      <div class="select-input">
        <div v-if="!presentItem && !filterable" class="default">{{ placeholder }}</div>
        <el-input
          v-if="!presentItem && filterable"
          v-model="search"
          :placeholder="placeholder"
        ></el-input>
        <template v-if="presentItem">
          <div class="present-top">
            <p>
              <span style="color: #5753E8;">{{ presentItem.code }}</span>
              <span style="color: #333333;margin-left: 12px">{{ presentItem.cnName }} |</span>
              <span style="color: #999999;">{{ presentItem.enName }}</span>
            </p>
          </div>
          <div class="present-bottom">
            <p>
              税号前2位：{{ presentItem.hsCode }}
            </p>
          </div>
        </template>
        <i
          v-show="!showClose"
          :class="[
            'el-icon-arrow-up',
            'el-icon--right',
            arrow ? 'arrowdown' : '',
          ]"
        ></i>
      </div>
      <el-dropdown-menu ref="dropdownMenu" slot="dropdown" :style="{width: width, maxHeight: '200px', overflow: 'auto'}">
        <template v-if="dropdownItems.length">
          <el-dropdown-item
            v-for="item in dropdownItems"
            :key="item.id"
            :command="item.code"
            class="dropdownItems"
          >
            <div class="items">
              <p>
                <span style="color: #5753E8;">{{ item.code }}</span>
                <span style="color: #333333;margin-left: 12px">{{ item.cnName }} |</span>
                <span style="color: #999999;">{{ item.enName }}</span>
              </p>
              <p>
                税号前2位：{{ item.hsCode }}
              </p>
            </div>
          </el-dropdown-item>
        </template>
        <template v-else>
          <p class="empty">无数据</p>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
    <i
      v-show="showClose"
      :class="[
        'el-icon-circle-close'
      ]"
      @click="close"
    ></i>
  </div>
</template>

<script>
export default {
  filters: {
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    }
  },
  props: {
    selectItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择NAICS Code'
    },
    filterable: {
      type: Boolean,
      default: true
    },
    showEin: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '670px'
    }
  },
  data() {
    return {
      arrow: false,
      presentItem: null,
      active: null,
      showClose: false,
      search: ''
    }
  },
  computed: {
    dropdownItems() {
      let dropdownItems
      const srarchVal = this.search.toLowerCase()
      if (!this.search) {
        dropdownItems = this.selectItems.map((a) => {
          return {
            ...a
          }
        })
      } else {
        dropdownItems = this.selectItems.filter(a => a.code.toLowerCase().indexOf(srarchVal) > -1).map((a) => {
          return {
            ...a
          }
        })
      }
      return dropdownItems
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val) {
        this.search = ''
        if (val) {
          this.presentItem = this.selectItems.find(a => val === a.code)
          this.presentItem && this.$emit('input', this.presentItem?.code)
        } else {
          this.presentItem = null
          this.$emit('input', '')
        }
      }
    }
  },
  methods: {
    visibleChange(e) {
      this.arrow = e
    },
    chooseItem(e) {
      this.presentItem = this.selectItems.find(a => e === a.code)
      this.search = ''
      this.$emit('input', this.presentItem.code)
    },
    reset() {
      this.presentItem = undefined
      this.$emit('input', '')
    },
    mouseenter() {
      this.presentItem && (this.showClose = true)
    },
    close() {
      this.presentItem = undefined
      this.$emit('input', '')
    }
  }
}
</script>

<style scoped lang="less">
.my-select {
  position: relative;
  width: 100%;
  .el-dropdown {
    display: block;
  }
  .el-input {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    &:deep(input) {
      height: 100%;
      border: 0;
    }
  }
  .select-input {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    width: 100%;
    min-height: 45px;
    height: auto;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #EEEEEE;
    cursor: pointer;
    padding: 8px 66px 8px 0;
    box-sizing: border-box;
    .default {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #CDCDCD;
    }
    .present-top {
      display: flex;
      margin-left: 8px;
      flex-wrap: wrap;
      .tag {
        display: flex;
        align-items: center;
      }
      .label {
        background: rgba(53, 186, 131, .1);
        border-radius: 4px 4px 4px 4px;
        padding: 4px 10px;
        box-sizing: border-box;
        color: #35BA83;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #35BA83;
        margin-right: 4px;
        line-height: normal;
      }
      .label-info {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: normal;
      }
    }
    .present-bottom {
      margin-left: 8px;
      line-height: normal;
      p {
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
    .el-icon--right {
      position: absolute;
      right: 16px;
      top: 50%;
      color: #c0c4cc;
      font-size: 14px;
      transition: transform 0.3s;
      transform: translateY(-50%) rotateZ(180deg);
    }
    .el-icon-circle-close {
      z-index: 99999;
    }
    .arrowdown {
      transform: translateY(-50%) rotateZ(0deg);
    }
  }
  .el-icon-circle-close {
    position: absolute;
    right: 16px;
    top: 50%;
    color: #c0c4cc;
    font-size: 14px;
    transition: transform 0.3s;
    transform: translateY(-50%) rotateZ(180deg);
    cursor: pointer;
  }
}
.dropdownItems {
  border-bottom: 1px dashed #DBE4F2;
  .items {
    line-height: 30px;
  }
  .code {
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #35BA83;
    line-height: 16px;
    padding: 4px 4px;
    background: rgba(53, 186, 131, .1);
  }
  .postalCode {
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #35BA83;
    line-height: 16px;
    margin-left: 16px;
    padding: 4px 4px;
    background: rgba(53, 186, 131, .1);
  }
}
/deep/ .empty {
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
